import styled from 'styled-components';

export const StyledDeviceCard = styled.div<{ position: { x: number; y: number }; isFixed?: boolean }>`
  position: ${props => (props.isFixed ? 'fixed' : 'absolute')};
  left: ${props => props.position.x}px;
  top: ${props => props.position.y}px;
  width: 224px;
  height: 356px;

  z-index: ${props => (props.isFixed ? 1000 : 3)};

  .form-container {
    padding: ${({ theme: { token } }) => token.paddingSM}px;
    max-height: 370px;
    overflow-y: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .form-container::-webkit-scrollbar {
    display: none;
  }

  .checkbox-list-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 150px;
    overflow-y: auto;
    flex-wrap: nowrap;
  }

  .button-container {
    display: flex;
    justify-content: space-around;
    width: 100%;
  }
`;
